import { render } from "./App.vue?vue&type=template&id=05a93948"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=05a93948&lang=css"

import exportComponent from "E:\\vue项目\\快递天气\\嗡嗡天气\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__